// src/utils/questionEngineResultNavigation.js

// Decide which results path to use for a given category/product.
// Returns a string path, e.g. "/vehicleQuoteResults"
export const getResultsPathForFlow = (category, product) => {
  // FAMILY
  if (category === 'Family' && product === 'LifeInsurance') {
    return '/lifeQuoteResults';
  }
  if (category === 'Family' && product === 'FuneralInsurance') {
    return '/funeralQuoteResults';
  }
  if (category === 'Family' && product === 'PetInsurance') {
    return '/petQuoteResults';
  }
  if (category === 'Family' && product === 'TravelInsurance') {
    return '/travelQuoteResults';
  }

  // VEHICLE
  if (
    category === 'Vehicle' &&
    (product === 'CarInsurance' ||
      product === 'ReturningUser' ||
      product === 'AdditionalDriver')
  ) {
    return '/vehicleQuoteResults';
  }

  if (category === 'Vehicle' && product === 'Scratch&DentCover') {
    return '/scratchAndDentQuoteResults'; // No dedicated results page yet
  }

  if (category === 'Vehicle' && product === 'Tyre&RimCover') {
    return '/tyreAndRimQuoteResults'; // No dedicated results page yet
  }
  if (category === 'Vehicle' && product === 'VehicleTracking') {
    return '/vehicleTrackingQuoteResults';
  }
  if (category === 'Vehicle' && product === 'ServicePlans') {
    return '/servicePlansQuoteResults';
  }

  if (category === 'Vehicle' && product === 'MotorWarranty') {
    return '/motorWarrantyQuoteResults'; // No dedicated results page yet
  }
  if (
    category === 'Vehicle' &&
    (product === 'MotorcycleInsurance' ||
      product === 'AdditionalMotorCycleDriver')
  ) {
    return '/motorcycleQuoteResults';
  }

  // HEALTH
  if (category === 'Health' && product === 'GapCover') {
    return '/medicalGapQuoteResults';
  }
  if (category === 'Health' && product === 'MedicalAid') {
    return '/medicalAidQuoteResults';
  }
  if (category === 'Health' && product === 'MedicalInsurance') {
    return '/medicalInsuranceQuoteResults';
  }

  // MONEY
  if (category === 'Money' && product === 'DebtCounselling') {
    return '/debtCounsellingQuoteResults';
  }

  if (category === 'Money' && product === 'PersonalLoans') {
    return '/personalLoanQuoteResults';
  }

  if (category === 'Money' && product === 'DebtConsolidation') {
    return '/debtConsolidationQuoteResults';
  }

  //Business
  if (category === 'Business' && product === 'BusinessInsurance') {
    return '/businessInsuranceQuoteResults';
  }
  if (category === 'Business' && product === 'BusinessLegalCover') {
    return '/businessLegalCoverQuoteResults';
  }
  if (category === 'Business' && product === 'CommercialProperty') {
    return '/commercialPropertyQuoteResults';
  }
  if (category === 'Business' && product === 'ProfessionalLiability') {
    return '/professionalLiabilityQuoteResults';
  }
  if (category === 'Business' && product === 'EmployeeBenefits') {
    return '/employeeBenefitsCallbackRequest';
  }

  //Home
  if (category === 'Home' && product === 'BuildingInsurance') {
    return '/buildingInsuranceQuoteResults';
  }

  if (category === 'Home' && product === 'HomeContentsCover') {
    return '/homeContentsQuoteResults';
  }

  if (category === 'Bundle' && product === 'CombinedQuotes') {
    return '/combinedInsuranceQuoteResults';
  }

  //Other
  if (category === 'Other' && product === 'FibreInternet') {
    return '/fibreQuoteResults';
  }

  // Fallback
  return '/otherQuoteResults';
};
